import { MainResponse } from '../../main-response.model';
import { HuyenItem } from './huyen-item.model';

export class ListHuyenResponse extends MainResponse {
    object: HuyenItem[] = [];
     
    constructor(obj = null) {
        super();
        obj = obj || {};
        this.init(obj);
        this.object = [];
        if (obj.object && obj.object instanceof Array) {
            obj.object.forEach((item) => {
                this.object.push(new HuyenItem(item));
            })
        }
    }
}